(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('EpmParamsDeleteController',EpmParamsDeleteController);

    EpmParamsDeleteController.$inject = ['$uibModalInstance', 'entity', 'EpmParams'];

    function EpmParamsDeleteController($uibModalInstance, entity, EpmParams) {
        var vm = this;

        vm.epmParams = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EpmParams.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
